@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.codeSplitLoader {
  opacity: 0;
  animation: fadeIn 0.3s ease-out 0.2s forwards;
}

